import { userSettingsService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    loading: true,
    saving: false
  }
}

const actions = {
  getCurrentUserSettings ({ commit }) {
    return userSettingsService.getCurrentUserSettings()
      .then(data => {
        commit('getCurrentUserSettingsSuccess', data.result)
        return data.result
      }).catch(error => {
        commit('getCurrentUserSettingsError', error)
        return Promise.reject(error)
      })
  },

  saveCurrentUserSettings ({ commit }, userSettings) {
    return userSettingsService.saveCurrentUserSettings(userSettings)
      .then(data => {
        commit('saveCurrentUserSettingsSuccess', data.result)
        return data.result
      }).catch(error => {
        return Promise.reject(error)
      })
  }
}

const mutations = {
  getCurrentUserSettingsSuccess (state) {
    state.all.loading = false
  },
  getCurrentUserSettingsError (state, error) {
    state.all.loading = false
    Vue.prototype.$toast(error, 'error')
  },
  saveCurrentUserSettingsSuccess (state) {
    state.all.loading = false
    Vue.prototype.$toast('Inställningar sparade', 'success')
  },
  saveCurrentUserSettingsError (state, error) {
    state.all.loading = false
    Vue.prototype.$toast(error)
  }
}

export const userSettings = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user-settings.module.js